export class PasswordExpiredError extends Error {
  constructor(error) {
    super(error)
    this.responseData = error.response.data;
  }
}